import { SvgProps } from "../../../types";

const ReportsSvg = (props: SvgProps) => (
  <svg
    width={props.width ?? 20}
    height={props.height ?? 25}
    viewBox="0 0 20 25"
    fill="none"
    {...props}
  >
    <path
      d="M5 12.5V10H15V12.5H5ZM5 7.5V5H15V7.5H5ZM2.5 15H11.875C12.4792 15 13.0417 15.1302 13.5625 15.3906C14.0833 15.651 14.5208 16.0208 14.875 16.5L17.5 19.9375V2.5H2.5V15ZM2.5 22.5H16.3125L12.9062 18.0312C12.7812 17.8646 12.6302 17.7344 12.4531 17.6406C12.276 17.5469 12.0833 17.5 11.875 17.5H2.5V22.5ZM17.5 25H2.5C1.8125 25 1.22396 24.7552 0.734375 24.2656C0.244792 23.776 0 23.1875 0 22.5V2.5C0 1.8125 0.244792 1.22396 0.734375 0.734375C1.22396 0.244792 1.8125 0 2.5 0H17.5C18.1875 0 18.776 0.244792 19.2656 0.734375C19.7552 1.22396 20 1.8125 20 2.5V22.5C20 23.1875 19.7552 23.776 19.2656 24.2656C18.776 24.7552 18.1875 25 17.5 25Z"
      fill={props.fill ?? "#1F1F1F"}
    />
  </svg>
);
export default ReportsSvg;
